import * as domtools from '@design.estate/dees-domtools';

import { html, render } from '@design.estate/dees-element';
import './elements/dotglobal-app.js';


const run = async () => {
  const domtoolsInstance = await domtools.DomTools.setupDomTools();
  domtools.elementBasic.setup();
  domtoolsInstance.setWebsiteInfo({
    metaObject: {
      title: 'foss.global - public code hosting',
      description:
        'Public discovery surface for open-source repositories.',
      canonicalDomain: 'https://foss.global',
    },
  });

  // Resolve the persisted theme (with the one-time Apple light migration) so the
  // page background matches before <dotglobal-app> paints, avoiding a flash.
  let storedTheme: 'dark' | 'light' = 'light';
  try {
    const storage = globalThis.localStorage;
    if (storage && !storage.getItem('fg.theme.appleMigrated')) {
      storage.setItem('fg.theme', 'light');
      storage.setItem('fg.theme.appleMigrated', '1');
    }
    storedTheme = storage?.getItem('fg.theme') === 'dark' ? 'dark' : 'light';
  } catch {
    storedTheme = 'light';
  }
  const pageBackground = storedTheme === 'dark' ? '#1c1c1e' : '#ffffff';

  const mainTemplate = html`
    <style>
      html {
        min-height: 100%;
        background: ${pageBackground};
      }
      body {
        margin: 0px;
        min-height: 100%;
        background: ${pageBackground};
      }
    </style>
    <dotglobal-app></dotglobal-app>
  `;

  render(mainTemplate, document.body);
};

run();
